module.exports = __webpack_public_path__ + "img/qtup.b03c075f.png";